import React, { useState, useRef, useEffect } from "react";


export default function MaterialStudy() {

    var sectionStyle1 = 'iron ball.png'
    var sectionStyle2 = 'Untitled-4.png'
    var sectionStyle3 = 'Untitled-6.png'
    var sectionStyle4 = 'Untitled-7.png'
    var sectionStyle5 = 'Untitled-8.png'
    var sectionStyle6 = 'Untitled-9.png'
    var sectionStyle7 = 'Untitled-10.png'
    var sectionStyle8 = 'Untitled-11.png'
 

    var sections = [ sectionStyle1, sectionStyle2, sectionStyle3, sectionStyle4, sectionStyle5, sectionStyle6, sectionStyle7, sectionStyle8]

    const [toggle, setToggle] = useState(false)
    var [sectionStyle, setStyle] = useState("")

    
    
    return (
        <>
            <div className="parent">
                <div className="mStudy" >
                    <a href="/"><button  className="left-slide"><img src="back_arrow.svg" /></button></a>
                    <img className="msTitle" src="Portfolio Fonts09.png"/>
                    {toggle && (
                        <div className="enlarged">
                            <button onClick={ (e) => setToggle(false) }  className="close"></button>
                            <img src={sectionStyle}/>
                        </div>
                    )}
                    <ul className="corner_left">
                        <li onClick={ (e) => setStyle(sectionStyle1) & setToggle(true) } ><img src={sections[0]}/></li>
                        <li onClick={ (e) => setStyle(sectionStyle2) & setToggle(true) } ><img src={sections[1]}/></li>
                        <li onClick={ (e) => setStyle(sectionStyle3) & setToggle(true) } ><img src={sections[2]}/></li>
                        <li onClick={ (e) => setStyle(sectionStyle4) & setToggle(true) }><img src={sections[3]}/></li>
                        <li onClick={ (e) => setStyle(sectionStyle5) & setToggle(true) }><img src={sections[4]}/></li>
                        <li onClick={ (e) => setStyle(sectionStyle6) & setToggle(true) }><img src={sections[5]}/></li>
                        <li onClick={ (e) => setStyle(sectionStyle7) & setToggle(true) }><img src={sections[6]}/></li>
                        <li onClick={ (e) => setStyle(sectionStyle8) & setToggle(true) }><img src={sections[7]}/></li>
                    </ul>
                </div>
            </div>
        </>
    );
}